const digitalTechnologiesAtTheStageOfPatientCommunication = `
        Today, there is a problem related to communication between dentists and patients at the consultation stage. The
        problem is related to the fact that a lot of complex methods of patient rehabilitation have appeared.
      </p>
      <p>
        Now doctors need not only to correctly diagnose dental pathology, but also to inform patients about all possible
        and current ways to solve this problem through visual visualization. To do this, doctors continue to use
        outdated and ineffective methods such as paper and pen.
      </p>
      <p>
        In the Internet age, patients independently search for ways to solve their problem online, then collect and
        prepare information for their treating doctors that they believe will help to solve the problem in the best
        possible way.
      </p>
      <p>
        In this situation, dentists simply need a program that allows them to visually visualize and clearly explain
        their arguments to patients in conversations with patients. Dentists need a program that will help to convince
        patients to choose the most reliable and high-quality treatment plan they offer. The desktop application for
        motivating patients - Dental Bot 3D will perfectly deal with this task.
      </p>
      <h2>Is a digit needed at the stage of patient consultation?</h2>
      <p>
        Today, the digit is a BRAND. The number of dental companies that position themselves as digital clinics only
        increases every year.
      </p>
      <p>
        Digital technologies in dentistry have already become an integral part of all technological processes. Doctors
        take impressions using intraoral scanning. Digital technologies are used to collect X-ray results, store patient
        medical data and plan patient rehabilitation. Administration and scheduling of seeing patients also take place
        in the digit.
      </p>
      <p>
        Digital technologies in dentistry are useful to implement at the stage of patient consultation. This approach
        will help to emphasize the high technology and premium quality of the dental company.
      </p>
      <h2>What can the digit give at the stage of patient communication? </h2>
      <p>The implementation of digital technologies provides doctors and dental clinics with:</p>
      <p>
        - image-based and high-tech approach to patient consultation and further work with them;
        <br /> - reduced time for seeing patients (due to the patient's independent work with an training and
        information panel);
        <br /> - the possibility of viewing all structures in detail, as well as visualizing the end result of
        rehabilitation even before it begins;
        <br /> - improved communication between patients and doctors;
        <br /> - improved business processes (training young employees, optimizing the time for seeing each patient,
        moving towards online consultations and telemedicine, administration and personnel management);
        <br /> - online preliminary patient consultation.
      </p>
      <h2>What do doctors expect from the digit at the stage of patient communication?</h2>
      <p>
        Colleagial Studio specialists conducted a survey among top specialists in the field of dentistry and came to the
        conclusion that any modern dental clinic needs:
      </p>
      <p>
        - an application that will allow you to visualize clinical cases and current methods of solutions;
        <br /> - to use motivational content to choose a more practical and reliable structure;
        <br /> - the possibility of providing a dental application for patients, in which clinic visitors can
        independently study their problem while waiting for a dentist appointment;
        <br /> - an argument base for doctors that would allow them to convince patients to choose more reliable and
        practical treatment methods;
        <br /> - to create documents describing a treatment plan online;
        <br /> - the possibility of online viewing a rehabilitation plan in 3D online by patients outside the clinic
        together with family and friends.
      </p>
      <h2>Solution to the problem</h2>
      <p>
        After collecting and studying the above information, the team of Collegial Studio has developed a unique desktop
        application for motivating patients— Dental Bot 3D.
      </p>
      <p>
        The uniqueness of this program lies in the 3D formula that allows you to visualize in space any clinical cases,
        as well as all the main modern methods of patient rehabilitation with adentia or aesthetic problems.
      </p>
      <p>
        This application has an intuitive and simple interface that allows patients to work with the program on their
        own. For this purpose, additional tips and training video content have been developed.
      </p>
      <h2>Dental Bot 3D is a tool to improve your business.</h2>
      <p>Dental Bot 3D is a high-tech tool for selling treatment plans.</p>
      <p>
        Dental business owners who have chosen the Dental Bot 3D application have a great opportunity to distinguish their
        clinic from others.
      </p>
      <p>
        Dental Bot 3D is also a huge argument base for dentists to help to justify their decisions to patients. By using
        the Dental Bot 3D desktop application for motivating patients, doctors can quietly encourage patients to make the
        best choice, while maintaining patient confidence that they made the decisions on their own.
      </p>
      <p>
        The Dental Bot 3D system will also be useful in training young specialists in dental clinics. They will learn to
        work faster and sell treatment plans more professionally using the application.
      </p>
      <p>
        Dental Bot 3D will allow you to develop a unified protocol for patient consultation in the clinic. This, in turn,
        will improve the company's business processes.
      </p>
      <h2>The key idea of using Dental Bot 3D.</h2>
      <p>
        The application is designed for at least two devices. This can be a tablet in the waiting room and a monitor in
        the doctor's office.
      </p>
      <p>
        The first acquaintance of the patient with the program can take place in the dentist's waiting room, where he
        will be offered a tablet with the application. Then the patient will be able to independently study his dental
        problem and find ways to solve it.
      </p>
      <p>
        When entering the doctor's office, the patient will be more prepared and thus it can be considered that he
        started the consultation on his own. In turn, the doctor will be able to better understand the problem and
        conduct the consultation more effectively after studying the data saved by the patient. This approach will help
        the doctor reduce the time of seeing patients as much as possible and hold more consultations.
      </p>
      <p>
        The world of modern dentistry needs digital tools for patient consultation and presentation of treatment plans.
        Digital technologies can provide a high-quality and even premium approach to working with the patient. The
        dental business needs digits at the stage of patient communication to fully digitalize the processes in the
        clinic.
      </p>
      <p>
        The digital dental product market can offer quality and mature solutions. The Dental Bot 3D system looks very
        profitable in this market and has every chance of conquering both modern clinics and dentistry of the future.
        Our team is dynamically developing the application and working on extending the existing functionality.
      </p>
  `;
export default digitalTechnologiesAtTheStageOfPatientCommunication;
